import React, { Component } from 'react';
import { Col, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import {
    SelectInput,
    TextInput,
    SlMoneyInput,
    SlSectionTitle,
    SlFormEntryRow,
    SlRadioButton,
    SlSectionLabel,
    SlDropdown
} from '../editors'
import { metadataService } from '../../_services'
import validator from 'validator';
import { newLoanConstants } from "../../_constants";

export class AddressInfo extends Component {
    constructor(props) {
        super(props);

        let propsValue = this.props.value;

        this.state = {
            visited: false,
            rentOrOwn: {
                rent: 0,
                own: 1
            },
            formValue: this.getFormValueFromProps(propsValue),
            fieldErrors: [],
            isStateSelectOpen: false,
            isResidenceTypeOpen: false,
        };

        this.handleInput = this.handleInput.bind(this);
        this.handleChangeState = this.handleChangeState.bind(this);
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.getCityState = this.getCityState.bind(this);
    }

    componentDidMount() {
        if (this.props.isValid) {
            var validation = this.getValidationErrors(this.state);
            this.props.isValid(this.props.name, validation.isValid);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            var validation = this.getValidationErrors(this.state);
            this.props.isValid(this.props.name, validation.isValid);
            this.setState({ formValue: this.getFormValueFromProps(this.props.value) });
        }
    }

    getFormValueFromProps(propsValue) {
        let formValue = {
            address1: propsValue.address1 ? propsValue.address1 : '',
            address2: propsValue.address2 ? propsValue.address2 : '',
            city: propsValue.city ? propsValue.city : '',
            state: propsValue.state ? propsValue.state : '',
            postalCode: propsValue.postalCode ? propsValue.postalCode : '',
            years: propsValue.years != null? propsValue.years  : '',
            months: propsValue.months != null ? propsValue.months : '',
            rentOrOwn: propsValue.rentOrOwn ? propsValue.rentOrOwn : 0,
            monthlyResidencePayment: propsValue.monthlyResidencePayment != null ? propsValue.monthlyResidencePayment : '',
            residenceType: propsValue.residenceType != null ? propsValue.residenceType : '',
        };

        return formValue;
    }

    handleOnBlur = ({ target: { name, value } }) => {

        if (name === "PostalCode" && value && value.length === 5) {
            this.getCityState(value);
        }

        this.setState({ visited: true });
    }

    getCityState(postalCode) {
        metadataService.getCityStateByZip(postalCode).then(response => {
            var data = response.data;
            if (data) {

                const formValue = this.state.formValue;
                let newState = {
                    formValue: formValue
                };

                this.handleInput({target: { name:"City", value:data.city }});
                this.handleInput({target: { name:"State", value: data.state }});
            }
        });
    }

    handleInput = ({ target: { name, value } }) => {

        const formValue = { ...this.state.formValue, [metadataService.jsonFieldName(name)]: value };
        let newState = {
            ...this.state,
            formValue: formValue
        };

        if (name === "rentOrOwn") {
            newState.formValue.rentOrOwn = parseInt(value); 
        }

        this.handleChangeState(newState);

        var validation = this.getValidationErrors(newState);
        this.props.isValid(name, validation.isValid);

        let returnValue = {
            isValid: validation.isValid,
            address1: newState.formValue.address1,
            address2: newState.formValue.address2,
            city: newState.formValue.city,
            state: newState.formValue.state,
            postalCode: newState.formValue.postalCode,
            years: newState.formValue.years,
            months: newState.formValue.months,
            rentOrOwn: newState.formValue.rentOrOwn,
            monthlyResidencePayment: newState.formValue.monthlyResidencePayment,
            residenceType: newState.formValue.residenceType,
        };

        this.props.onChange({ target: { name: this.props.name, value: returnValue } });
    };

    handleChangeState(newState) {
        this.setState(newState);
    }

    getValidationErrors(checkState) {
        let validation = {
            isValid: true,
            validationError: []
        };

        if (validator.isEmpty(checkState.formValue.address1)) {
            validation.isValid = false;
            validation.validationError.push({ fieldName: "Address1", messageName: "RequiredFieldNotSupplied" });
        }

        if (validator.isEmpty(checkState.formValue.city)) {
            validation.isValid = false;
            validation.validationError.push({ fieldName: "City", messageName: "RequiredFieldNotSupplied" });
        }

        if (validator.isEmpty(checkState.formValue.state)) {
            validation.isValid = false;
            validation.validationError.push({ fieldName: "State", messageName: "RequiredFieldNotSupplied" });
        }

        if (validator.isEmpty(checkState.formValue.postalCode + "")) {
            validation.isValid = false;
            validation.validationError.push({ fieldName: "PostalCode", messageName: "RequiredFieldNotSupplied" });
        }

        if (validator.isEmpty(checkState.formValue.years + "")) {
            validation.isValid = false;
            validation.validationError.push({ fieldName: "Years", messageName: "RequiredFieldNotSupplied" });
        }

        if (validator.isEmpty(checkState.formValue.months + "")) {
            validation.isValid = false;
            validation.validationError.push({ fieldName: "Months", messageName: "RequiredFieldNotSupplied" });
        }
        if (validator.isEmpty(checkState.formValue.residenceType + "")) {
            validation.isValid = false;
            validation.validationError.push({ fieldName: "ResidenceType", messageName: "RequiredFieldNotSupplied" });
        }
         
        if (validator.isEmpty(checkState.formValue.monthlyResidencePayment + "")) {
            validation.isValid = false;
            validation.validationError.push({
                fieldName: "MonthlyResidencePayment",
                messageName: "RequiredFieldNotSupplied"
            });
        } else { 
            if (validator.isNumeric(checkState.formValue.monthlyResidencePayment + '')
                && parseFloat(checkState.formValue.monthlyResidencePayment) > parseFloat(newLoanConstants.MAX_MONTHLY_RESIDENCE_PAYMENT)) {
                validation.validationError.push({ fieldName: "MonthlyResidencePayment", messageName: "RequiredFieldNotSupplied" });
                validation.isValid = false;
            }

        }
        
        return validation;
    }

    openDropdown = () => {
        this.setState({isStateSelectOpen: !this.state.isStateSelectOpen})
    }

    render() {
        return (
            <div>
                <SlFormEntryRow>
                    <TextInput
                        name="Address1"
                        label={metadataService.getFieldNameLabel("Address")}
                        value={this.state.formValue.address1}
                        fieldErrors={this.state.fieldErrors}
                        isRequired={true}
                        showLabel={this.props.showLabel}
                        maxLength={60}
                        disabled={this.props.readOnly}
                        onChange={this.handleInput} />
                </SlFormEntryRow>
                {/*<SlFormEntryRow>*/}
                {/*    <TextInput*/}
                {/*        name="Address2"*/}
                {/*        value={this.state.formValue.address2}*/}
                {/*        fieldErrors={this.state.fieldErrors}*/}
                {/*        isRequired={false}*/}
                {/*        showLabel={this.props.showLabel}*/}
                {/*        maxLength={60}*/}
                {/*        disabled={this.props.readOnly}*/}
                {/*        onChange={this.handleInput} />*/}
                {/*</SlFormEntryRow>*/}
                <SlFormEntryRow>
                    <Row>
                        <Col>
                            <TextInput
                                name="PostalCode"
                                value={this.state.formValue.postalCode}
                                fieldErrors={this.state.fieldErrors}
                                isRequired={true}
                                onChange={this.handleInput}
                                onBlur={this.handleOnBlur}
                                showLabel={this.props.showLabel}
                                type="number"
                                maxLength={5}
                                disabled={this.props.readOnly} />
                        </Col>
                        <Col>
                            <SlDropdown
                                Name="State"
                                value={this.state.formValue.state}
                                isRequired={true}
                                options={metadataService.getLookup("state")}
                                handleChange={this.handleInput}
                                open={this.state.isStateSelectOpen}
                                openDropdown={this.openDropdown}
                                fieldErrors={this.state.fieldErrors}
                                showLabel={this.props.showLabel}
                                placeholder={"Select " + metadataService.getFieldNameLabel("State")}
                                disabled={this.props.readOnly} 
                            />
                        </Col>
                    </Row>
                </SlFormEntryRow>
                <SlFormEntryRow>
                    <TextInput
                        name="City"
                        value={this.state.formValue.city}
                        fieldErrors={this.state.fieldErrors}
                        showLabel={this.props.showLabel}
                        isRequired={true}
                        onChange={this.handleInput}
                        maxLength={60}
                        disabled={this.props.readOnly}/>
                </SlFormEntryRow>
                <SlSectionLabel sectionName="NumberOfYearsMonthsInHome" />
                <SlFormEntryRow>
                    <Row>
                        <Col>
                            <TextInput
                                name="Years"
                                type="number"
                                label={metadataService.getFieldNameLabel("Years")}
                                placeholder={metadataService.getFieldNameLabel("Years")}
                                showLabel={this.props.showLabel}
                                fieldErrors={this.state.fieldErrors}
                                isRequired={true}
                                value={this.state.formValue.years}
                                min={0}
                                max={99}
                                maxLength={2}
                                onChange={this.handleInput}
                                disabled={this.props.readOnly}/>
                        </Col>
                        <Col>
                            <TextInput
                                name="Months"
                                type="number"
                                label={metadataService.getFieldNameLabel("Months")}
                                placeholder={metadataService.getFieldNameLabel("Months")}
                                value={this.state.formValue.months}
                                fieldErrors={this.state.fieldErrors}
                                isRequired={true}
                                showLabel={this.props.showLabel}
                                min={0}
                                max={11}
                                maxLength={2}
                                onChange={this.handleInput}
                                disabled={this.props.readOnly}/>
                        </Col>
                    </Row>
                </SlFormEntryRow>
                <SlSectionLabel sectionName="DoYouRentOrOwn" />
                <SlFormEntryRow>
                    <SlDropdown
                                Name="ResidenceType"
                                value={this.state.formValue.residenceType + ""}
                                isRequired={true}
                                options={metadataService.getLookup("residenceType")}
                                handleChange={this.handleInput}
                                open={this.state.isResidenceTypeOpen}
                                openDropdown={() => this.setState({isResidenceTypeOpen: !this.state.isResidenceTypeOpen})}
                                fieldErrors={this.state.fieldErrors}
                                showLabel={this.props.showLabel}
                                placeholder={"Select " + metadataService.getFieldNameLabel("ResidenceType")}
                                disabled={this.props.readOnly} 
                    />
                </SlFormEntryRow>
                <SlFormEntryRow>                         
                    {
                                Number(this.state.formValue.residenceType + "") === metadataService.ENUM_RESIDENCE_TYPE.OWN ? <SlMoneyInput
                                name="MonthlyResidencePayment"
                                type="number"
                                label={metadataService.getFieldNameLabel("MonthlyMortgagePayment")}
                                placeholder={metadataService.getFieldNameLabel("MonthlyMortgagePayment")}
                                value={this.state.formValue.monthlyResidencePayment + ""}
                                fieldErrors={this.state.fieldErrors}
                                isRequired={true}
                                showLabel={this.props.showLabel}
                                onChange={this.handleInput}
                                disabled={this.props.readOnly}/>
                                : Number(this.state.formValue.residenceType + "") === metadataService.ENUM_RESIDENCE_TYPE.RENT ? <SlMoneyInput
                                name="MonthlyResidencePayment"
                                type="number"
                                label={metadataService.getFieldNameLabel("MonthlyResidencePayment")}
                                placeholder={metadataService.getFieldNameLabel("MonthlyResidencePayment")}
                                value={this.state.formValue.monthlyResidencePayment + ""}
                                fieldErrors={this.state.fieldErrors}
                                isRequired={true}
                                showLabel={this.props.showLabel}
                                onChange={this.handleInput}
                                disabled={this.props.readOnly} />
                                : <SlMoneyInput
                                name="MonthlyResidencePayment"
                                type="number"
                                label={metadataService.getFieldNameLabel("MonthlyResidenceExpense")}
                                placeholder={metadataService.getFieldNameLabel("MonthlyResidenceExpense")}
                                value={this.state.formValue.monthlyResidencePayment + ""}
                                fieldErrors={this.state.fieldErrors}
                                isRequired={true}
                                showLabel={this.props.showLabel}
                                onChange={this.handleInput}
                                disabled={this.props.readOnly} />
                    }
                </SlFormEntryRow>
            </div>
        );
    }
}

//Define prop types
AddressInfo.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    showLabel: PropTypes.bool,
    value: PropTypes.object,
    fieldErrors: PropTypes.array,
    isValid: PropTypes.func,
    readOnly: PropTypes.bool
}
AddressInfo.defaultProps = {
    showLabel: true,
    value: {},
    readOnly: false
}


// WEBPACK FOOTER //
// ./src/components/subcomponents/AddressInfo.js